(function () {
  const formScroll = window.MinimogFormScroll || {};

  function scrollToElement(element) {
    if (formScroll.scrollToElement) {
      formScroll.scrollToElement(element);
      return;
    }

    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  function clearFormFeedback(form) {
    form.querySelectorAll('.m-comment-form__ajax-feedback').forEach(function (node) {
      node.remove();
    });
  }

  function showFormFeedback(form, type, message) {
    clearFormFeedback(form);

    const feedback = document.createElement('div');
    feedback.className = 'm-comment-form__ajax-feedback';

    if (type === 'success') {
      feedback.innerHTML =
        '<p class="m-comment-section__form-message" role="status" aria-live="polite"></p>';
      feedback.querySelector('p').textContent = message;
    } else {
      feedback.innerHTML =
        '<ul role="alert" aria-live="assertive"><li class="notification warning show"></li></ul>';
      feedback.querySelector('li').textContent = message;
    }

    const header = form.querySelector('.m-comment-form__header');
    if (header) {
      header.insertAdjacentElement('afterend', feedback);
    } else {
      form.prepend(feedback);
    }

    scrollToElement(feedback);
  }

  function updateCommentSection(doc) {
    const responseSection = doc.querySelector('.m-comment-section');
    const currentSection = document.querySelector('.m-comment-section');
    const commentForm = document.getElementById('m-leave-comment');

    if (!responseSection || !commentForm) return;

    const importedSection = document.importNode(responseSection, true);

    if (currentSection) {
      currentSection.replaceWith(importedSection);
      return;
    }

    commentForm.insertAdjacentElement('beforebegin', importedSection);
  }

  function initCommentForm(form) {
    if (form.dataset.ajaxComment === 'true') return;
    form.dataset.ajaxComment = 'true';

    const wrapper = form.closest('#m-leave-comment');
    const submitButton = form.querySelector('[type="submit"]');
    const successMessage = wrapper
      ? wrapper.dataset.commentSuccess
      : 'Your comment was posted successfully! Thank you!';
    const moderatedMessage = wrapper
      ? wrapper.dataset.commentSuccessModerated
      : 'Your comment was posted successfully. We will publish it in a little while, as our blog is moderated.';
    const isModerated = wrapper && wrapper.dataset.blogModerated === 'true';

    form.addEventListener('submit', function (event) {
      event.preventDefault();

      clearFormFeedback(form);

      if (submitButton) {
        submitButton.disabled = true;
        submitButton.classList.add('is-loading');
      }

      fetch(form.action, {
        method: 'POST',
        body: new FormData(form),
        headers: {
          Accept: 'text/html',
        },
      })
        .then(function (response) {
          return response.text();
        })
        .then(function (html) {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const responseForm =
            doc.querySelector('#m-leave-comment form') || doc.querySelector('.js-comment-ajax-form');

          const errorList = responseForm && responseForm.querySelector('[role="alert"]');
          if (errorList && errorList.textContent.trim()) {
            showFormFeedback(form, 'error', errorList.textContent.trim());
            return;
          }

          const successNode =
            (responseForm && responseForm.querySelector('.m-comment-section__form-message')) ||
            doc.querySelector('.m-comment-section__form-message');

          updateCommentSection(doc);
          form.reset();
          showFormFeedback(
            form,
            'success',
            (successNode && successNode.textContent.trim()) ||
              (isModerated ? moderatedMessage : successMessage)
          );

          if (window.location.search || window.location.hash) {
            window.history.replaceState({}, document.title, window.location.pathname);
          }
        })
        .catch(function () {
          showFormFeedback(form, 'error', 'Something went wrong. Please try again.');
        })
        .finally(function () {
          if (submitButton) {
            submitButton.disabled = false;
            submitButton.classList.remove('is-loading');
          }
        });
    });
  }

  function init() {
    document.querySelectorAll('.js-comment-ajax-form').forEach(initCommentForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
